import React, {useState} from "react";
import {
    Datagrid,
    DateField,
    Filter,
    List,
    SelectInput,
    SimpleShowLayout,
    TextField,
    TextInput,
    required,
    BooleanField,
    BooleanInput,
    NumberInput,
    NumberField,
    ReferenceInput,
    ArrayField,
    ArrayInput,
    ReferenceArrayInput,
    SelectArrayInput, AutocompleteInput, SimpleFormIterator
} from "react-admin";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import Emoji from "../../components/Emoji";
import {PersianDateExpirationDatePicker} from "../../components/PersianDatePickers";
import {ConversationInputTags} from "../conversation/conversationConstant";
import {Products} from "../../constants/choices";
import EditView from "../../components/EditView";

const PromotionFilter = (props) => (
  <Filter {...props}>
      <TextInput
          label="title"
          source={"title"}
      />
  </Filter>
);

export const PromotionList = (props) => (
  <List {...props} filters={<PromotionFilter/>}>
    <Datagrid rowClick="show">
        <TextField source="objectId"/>
        <TextField source="title"/>
        <DateField showTime={true} locales={"fa-IR"} source="startDate"/>
        <DateField showTime={true} locales={"fa-IR"} source="endDate"/>
        <NumberField source="percent"/>
        <BooleanField source="isDeleted"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </Datagrid>
  </List>
);

export const PromotionCreate = (props) => {
    const [startDate, setStartDate, ] = useState(new Date().setHours(0,0));
    function startDateChange(e){
        setStartDate(e._d.setHours(0,0))
    }
    const [endDate, setEndDate, ] = useState(new Date().setHours(0,0));
    function endDateChange(e){
        setEndDate(e._d.setHours(0,0))
    }

    return (
        <CreateView {...props} perPage={10}>
            <TextInput  source="title" validate={required()}/>
            <Emoji source="description" label="توضیحات"/>
            <NumberInput source="percent" validate={required()}/>
            <BooleanInput source="isDeleted" defaultValue={false}/>
            <PersianDateExpirationDatePicker
                name="startDate"
                value={startDate}
                onChange={startDateChange}
                label={"تاریخ شروع"}
            />
            <PersianDateExpirationDatePicker
                name="endDate"
                value={endDate}
                onChange={endDateChange}
                label={"تاریخ پایان"}
            />
            <ArrayInput source="adminPlansId">
                <SimpleFormIterator>
                    <TextInput source="plansId"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistIds">
                <SimpleFormIterator>
                    <TextInput source="specialistIds"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminClinicCategories">
                <SimpleFormIterator>
                    <TextInput source="clinicCategories"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistCardIds">
                <SimpleFormIterator>
                    <TextInput source="specialistCardIds"/>
                </SimpleFormIterator>
            </ArrayInput>
        </CreateView>
    );
}


export const PromotionEdit = (props) => {
    const [startDate, setStartDate, ] = useState(new Date().setHours(0,0));
    function startDateChange(e){
        setStartDate(e._d.setHours(0,0))
    }
    const [endDate, setEndDate, ] = useState(new Date().setHours(0,0));
    function endDateChange(e){
        setEndDate(e._d.setHours(0,0))
    }

    return (
        <EditView {...props} perPage={10}>
            <TextInput  source="title" validate={required()}/>
            <Emoji source="description" label="توضیحات"/>
            <NumberInput source="percent" validate={required()}/>
            <BooleanInput source="isDeleted" defaultValue={false}/>
            <PersianDateExpirationDatePicker
                name="startDate"
                value={startDate}
                onChange={startDateChange}
                label={"تاریخ شروع"}
            />
            <PersianDateExpirationDatePicker
                name="endDate"
                value={endDate}
                onChange={endDateChange}
                label={"تاریخ پایان"}
            />
            <ArrayInput source="adminPlansId">
                <SimpleFormIterator>
                    <TextInput source="plansId"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistIds">
                <SimpleFormIterator>
                    <TextInput source="specialistIds"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminClinicCategories">
                <SimpleFormIterator>
                    <TextInput source="clinicCategories"/>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="adminSpecialistCardIds">
                <SimpleFormIterator>
                    <TextInput source="specialistCardIds"/>
                </SimpleFormIterator>
            </ArrayInput>
        </EditView>
    );
}

export const PromotionShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <TextField source="title"/>
        <TextField source="description"/>
        <DateField showTime={true} locales={"fa-IR"} source="startDate"/>
        <DateField showTime={true} locales={"fa-IR"} source="endDate"/>
        <NumberField source="percent"/>
        <ArrayField source="adminPlansId">
            <Datagrid>
                <TextField source="plansId" />
            </Datagrid>
        </ArrayField>
        <ArrayField source="adminSpecialistIds">
            <Datagrid>
                <TextField source="specialistIds" />
            </Datagrid>
        </ArrayField>
        <ArrayField source="adminClinicCategories">
            <Datagrid>
                <TextField source="clinicCategories" />
            </Datagrid>
        </ArrayField>
        <ArrayField source="adminSpecialistCardIds">
            <Datagrid>
                <TextField source="specialistCardIds" />
            </Datagrid>
        </ArrayField>
        <BooleanField source="isDeleted"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </SimpleShowLayout>
  </ShowView>
);
